import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.is-extensible";
import "core-js/modules/es6.object.is-extensible";
import { useThemeUI } from 'theme-ui';
import { get, pipe, defaultTo } from 'lodash/fp';
export var themeProp = function themeProp(str) {
  return function (props) {
    return get("theme." + str, props);
  };
};

if (typeof themeProp !== 'undefined' && themeProp && themeProp === Object(themeProp) && Object.isExtensible(themeProp)) {
  Object.defineProperty(themeProp, '__filemeta', {
    configurable: true,
    value: {
      name: "themeProp",
      filename: "node_modules/gatsby-theme-docz/src/utils/theme.js"
    }
  });
}

export var usePrismTheme = function usePrismTheme() {
  var _useThemeUI = useThemeUI(),
      theme = _useThemeUI.theme,
      colorMode = _useThemeUI.colorMode;

  var getTheme = pipe(get('prismTheme'), defaultTo(get("prism." + colorMode, theme)));
  return getTheme(theme);
};

if (typeof usePrismTheme !== 'undefined' && usePrismTheme && usePrismTheme === Object(usePrismTheme) && Object.isExtensible(usePrismTheme)) {
  Object.defineProperty(usePrismTheme, '__filemeta', {
    configurable: true,
    value: {
      name: "usePrismTheme",
      filename: "node_modules/gatsby-theme-docz/src/utils/theme.js"
    }
  });
}